export { isClient } from './lib/is-client';
export {
  isAbsoluteUrl,
  addHttpsToUrl,
  getPreparedUrl,
  getUniqueUrl,
  getTeamsInviteUrl,
  validateURL,
} from './lib/url-utils';
export { randomString, capitalizeFirstLetter } from './lib/string-utils';
export { getLocaleDateTimeString, getLocaleDateStringWithDiffTime, getLocaleDateString } from './lib/date-utils';
export { setCookie } from './lib/set-cookie';
export { arrayMove, arrayHasIntersection } from './lib/array-utils';
export { addHttpsProtocolToUrl, isValidUrl, isValidInternalUrl } from './lib/is-valid-url';
export { patchObject, patchObjectMulti } from './lib/patch-object';
export { copyToClipboardFrom, copyTextToClipboard, copyToClipboard } from './lib/copy-to-clipboard';
export type { OptionalizeProps } from './lib/optionalize-props';
export type { Image } from './lib/image-utils';
export { generateImage, parseImage } from './lib/image-utils';
export { getPortalAuthLink } from './lib/navigation-utils';
export type { CropSize } from './lib/crop-image-utils';
export { getCropedFile } from './lib/crop-image-utils';
export { logger, decideLogLevelForError } from './lib/node-log';
export { convertBytes } from './lib/convert-bytes';
export { getFirstLetters, getUserDisplayName } from './lib/user-helper';
export { getTimeAgoString } from './lib/convert-time';
export { downloadFile } from './lib/download-file';
export { compareObjectsPartially, compareObjectsOmitProps } from './lib/object-utils';
export { downloadFromUrl } from './lib/download-from-url';
export { downloadFromIframe } from './lib/download-from-iframe';
export { getPermission } from './lib/get-permissions';
export { getErrorData } from './lib/get-error-data';
export { getBoxFileUrl } from './lib/get-box-file-url';
export { getIsMobile } from './lib/is-mobile';
export { isMac } from './lib/is-mac';
export { generateNoteGlobalId } from './lib/generate-note-global-id';
export { getUserLocale } from './lib/get-user-locale';
export { getPortalHasChanges } from './lib/changes';

export type { FileType } from './lib/file-type';
export { getFileTypeByName } from './lib/file-type';
export { capitalize, prefix } from './lib/text-utils';
export { plural } from './lib/plural';
export { validateEnumKey } from './lib/enum-utils';
export { roundHalfToEven } from './lib/round-half-to-event';
export { openTaskDetailedInDashboard, sendOpenTaskEvent } from './lib/open-task-detailed-in-dashboard';
export { timeoutPromise } from './lib/timeout';
export { getTasksAllowedActions } from './lib/get-tasks-allowed-actions';

export { getCookieValue } from './lib/cookie';
export { getWrapperProps, defaultBlockWrapper, getBlockLayoutInfo } from './lib/blocks';

export { getPaywallTitle } from './lib/get-paywall-title';

export { replaceNimbusDomains } from './lib/replace-nimbus-domains';
export { uuid } from './lib/uuid';
export { getPageType, getSettingsPageType } from './lib/get-page-type';
export { isLocalHost, getRequestUrl, getRequestDomain, getRequestSubdomain } from './lib/get-url';
export { findRequestOrganization, getOrgRedirectUrl } from './lib/get-organization';
export { positionTypeToMenuType, menuTypeToPositionType, getPortalWizardUrl } from './lib/portal';
export { hasAppsumoBundle } from './lib/appsumo';
export {
  getSubscriptionType,
  hasMaxSubscriptionPlan,
  mapSubscriptionType,
  mapPlanToSubscription,
} from './lib/get-subscription-type';
export type {
  IGetSubscriptionTypeParams,
  IGetSubscriptionType,
  IGetSubscriptionTypeStore,
} from './lib/get-subscription-type';
export type {
  NextAppRouterPushFunction,
  NextPageRouterPushFunction,
  NextRouterPushFunction,
  NextRouterOptions,
} from './lib/router-push';
export {
  getAdminClientUrl,
  getAdminClientDirectUrl,
  getAdminClientPath,
  getPricingClientUrl,
  getGuideClientUrl,
} from './lib/navigator';
export { onUserPilotLoad } from './lib/on-userpilot-load';
export { NextRouterType, routerPush } from './lib/router-push';
export { scrollToSidebarMenuItem } from './lib/scroll-to-sidebar-menuitem';
export { b64DecodeUnicode, GetMessageTask, convertMarkdownToDelta } from './lib/ai';
export { useNavHistoryHook, useNavHistory } from './lib/use-nav-history';
export { parseMenuItemId } from './lib/menu-item';
export { getDynamicVariableShortcut, getTextWithPreparedVariables } from './lib/dynamic-variable';
export { formatPrice } from './lib/format-price';
export { getSortFn } from './lib/sort';
export { getFilterMenuItemsByPrivileges } from './lib/get-filter-menu-items-by-privileges';
export { getNoteTemplateIdFromTile } from './lib/get-note-template-id-from-tile';
export { getFixedImageUrl } from './lib/get-fixed-image-url';
export { getTrialStartStoreInitialState } from './lib/get-trial-start-store-initial-state';
export { getNodeNameByType } from './lib/get-node-name-by-type';
export { calcProcessData } from './lib/calc-process-data';
export { decodeURIComponentKeys } from './lib/decode-uri-component-keys';
export { getLocalStorageValue } from './lib/get-local-storage-value';
export { generateTagId, tagsComparator, tagsNamesComparator } from './lib/tags';
export { humanReadableFileSize } from './lib/file-size';
export { hasAccess } from './lib/assert-access';
export { uploadFile, type AttachmentPart, type TempStoredFile } from './lib/upload-file';
export { prepareFileItemUrl } from './lib/prepare-file-item-url';
